<div class="float-right d-none d-sm-block">
  <b>Version: </b>{{ currentAppVersion }}
</div>
<strong>
  <span>Copyright &copy; {{ currentYear }}</span>
  <a
    href="https://www.alphastarav.com/"
    target="_blank"
    rel="noopener noreferrer"
    class="m-0">
    alphastarav.com</a
  >
  <span>.</span>
</strong>
<span> All rights reserved.</span>
